import React from "react";
import styled from "styled-components";

import LineSeedKrBd from "../../../../atoms/text/lineSeedKr/lineSeedKrBd";

const LSBdDisplay01 = (props) => {
  return <LSBdDisplay01Wrapper {...props} />;
};

export default LSBdDisplay01;

const LSBdDisplay01Wrapper = styled(LineSeedKrBd)`
  font-size: 20px;
  font-weight: 700;
  line-height: 28px;
  letter-spacing: -0.6px;

  color: #222222;
`;
